import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { ServiceStatusOfTodayBox } from "./../../../../Components/ServiceStatusOfTodayBox/ServiceStatusOfTodayBox";

import "./ServiceStatusOfTodayFormStepOne.scss";
import { useDeviceServiceData } from "../../ServiceForms/CreateServiceForm/ServiceHooks/useDeviceServiceData";
import moment from "moment";
const ServiceStatusOfTodayFormStepOne = (props) => {
  const { t } = useTranslation();
  const { values, form } = props;
  const { dayView, fetchServiceDayView } = useDeviceServiceData(values, form);

  useEffect(() => {
    if (!values?.selectDate) {
      form.change("selectDate", moment());
    }
    if (values?.selectDate) {
      const dateString = moment(values.selectDate).format("YYYY-MM-DD");
      fetchServiceDayView(dateString);
    }
  }, [values?.selectDate, form]);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={{ span: 2, offset: 5 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.selectDate")}*`}
            name="selectDate"
            data-cy="selectDate"
          />
        </Col>
      </Row>
      <div className="containerBox">
        {dayView?.technicians?.map((technician) => (
          <ServiceStatusOfTodayBox
            key={technician.uuid}
            technician={technician}
          />
        ))}
      </div>
    </div>
  );
};

export default ServiceStatusOfTodayFormStepOne;
